export default __webpack_public_path__ + "static/media/AXC_TOKEN_MIGRATION_TERMS_V2_202209.e0643e61.pdf";